export default function(_) {
  return typeof _ === 'number';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isNumber.js